<template>
	<div class="container stats-number-card">
		<div class="row">
			<div class="col-12 d-sm-block m-auto">
				<div class="d-inline-flex">
					<h3>{{value === '-' ? value : Math.round(value)}}</h3>
				</div>
				<h5 class="stats-number-card--label">{{label}}</h5>
			</div>
		</div>
		<hr class="d-none d-sm-block" />
		<div class="row stats-number-card--last">
			<div class="col-12">
				<i v-if="Math.round(improved_by) > 0"><img src="@/images/up.svg" /></i>
				<i v-else-if="Math.round(improved_by) < 0"><img src="@/images/down.svg" /></i>
				<i v-else-if="improved_by === '-'"></i>
				<i v-else>-</i>
				<span>{{last_label}}: <b>{{improved_by === '-' ? improved_by : Math.round(improved_by) + "%"}}</b></span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'label', 'value', 'improved_by', 'last_label', 'max_score'
		],

		watch: {
			venue(){

			}
		}
	}
</script>
